import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { BrandDetail } from '../../../features/brand/views/BrandDetail';
import * as core from '@bob/core-services';
import { defaultLocale } from '@bob/cold-data';
export function getStaticProps(_x) {
  return _getStaticProps.apply(this, arguments);
}

function _getStaticProps() {
  _getStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$locale, locale, params, brand;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? defaultLocale.code : _ref$locale, params = _ref.params;

            if (!(params === undefined)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              notFound: true
            });

          case 3:
            _context.next = 5;
            return core.brand.build.get({
              slug: params.brand,
              locale: locale
            });

          case 5:
            brand = _context.sent;

            if (!(brand === undefined)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              notFound: true
            });

          case 8:
            return _context.abrupt("return", {
              props: {
                brand: brand
              },
              revalidate: 10
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}

export function getStaticPaths(_x2) {
  return _getStaticPaths.apply(this, arguments);
}

function _getStaticPaths() {
  _getStaticPaths = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var _ref2$locales, locales, paths;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref2$locales = _ref2.locales, locales = _ref2$locales === void 0 ? [] : _ref2$locales;
            paths = [];
            _context3.next = 4;
            return Promise.all(locales.map( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
                var collection, _iterator, _step, brand;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return core.brand.build.getAllPartialCollection(locale);

                      case 2:
                        collection = _context2.sent;
                        _iterator = _createForOfIteratorHelper(collection);

                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            brand = _step.value;
                            paths.push({
                              params: {
                                brand: brand.slug
                              },
                              locale: locale
                            });
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 4:
            return _context3.abrupt("return", {
              paths: paths,
              fallback: 'blocking'
            });

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaticPaths.apply(this, arguments);
}

export default BrandDetail;